import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

function Loading({ forceCenter }) {
  return (
    <div className={clsx(
      'nav-initial-loading',
      'loading-icon-wrapper',
      'text-center',
      forceCenter && 'force-center',
    )}
    >
      <div>
        <i className="fa fa-spinner fa-pulse loading-icon-lg" />
      </div>
    </div>
  );
}

Loading.defaultProps = {
  forceCenter: false,
};

Loading.propTypes = {
  forceCenter: PropTypes.bool,
};

export default Loading;
